import { Stack } from "@mui/material";
import MandateFilters from "../pages/filters/MandateFilters";
import MandateTable from "../tables/MandateTable";

function Mandates() {

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <MandateFilters/>
                <MandateTable/>
            </Stack>
    );
}

export default Mandates;